export default "__VITE_ASSET__b8ba53fa__"